// ── 보스 프리셋 헬퍼 함수 ────────────────────────────────
// 캐릭터별로 3개 슬롯(preset1, preset2, preset3)을 가짐.
// 각 슬롯: { name: string, bosses: [{ sec, name, diff, partySize, partyMembers }] }

export function emptyPreset() {
  return { name: "", bosses: [] };
}

export function emptyPresets() {
  return { preset1: emptyPreset(), preset2: emptyPreset(), preset3: emptyPreset() };
}

/**
 * 프리셋의 보스 목록을 BossSection의 4개 state 형태로 변환
 * @param {Array} bosses - [{ sec, name, diff, partySize, partyMembers }]
 * @returns {{ checkedBosses, bossParty, bossPartyMembers, bossDiffs }}
 */
export function presetToBossState(bosses) {
  const checkedBosses = {};
  const bossParty = {};
  const bossPartyMembers = {};
  const bossDiffs = {};

  (bosses || []).forEach(b => {
    const bkey = `${b.sec}_${b.name}_${b.diff}`;
    checkedBosses[bkey] = true;
    bossParty[bkey] = b.partySize || 1;
    bossPartyMembers[bkey] = b.partyMembers || [];
    bossDiffs[`${b.sec}_${b.name}`] = b.diff;
  });

  return { checkedBosses, bossParty, bossPartyMembers, bossDiffs };
}

/**
 * 현재 체크된 보스 state를 프리셋 저장용 배열로 변환
 * @param {Object} checkedBosses
 * @param {Object} bossParty
 * @param {Object} bossPartyMembers
 * @returns {Array} bosses
 */
export function bossStateToPreset(checkedBosses, bossParty, bossPartyMembers) {
  return Object.entries(checkedBosses)
    .filter(([, v]) => v === true)
    .map(([bkey]) => {
      const parts = bkey.split("_");
      const sec = parts[0];
      const diff = parts[parts.length - 1];
      const name = parts.slice(1, -1).join("_");
      return {
        sec, name, diff,
        partySize: bossParty[bkey] || 1,
        partyMembers: bossPartyMembers[bkey] || [],
      };
    });
}
